const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: '瓜',
    time: '2小时前',
    content: '这个瓜我吃了三天了，越吃越上头！51黑料的更新速度真的快，比起其他平台这里信息最全，而且评论区氛围也好，大家都是理性吃瓜。',
    likes: 328,
  },
  {
    name: '娱乐圈观察员',
    avatar: '圈',
    time: '5小时前',
    content: '作为一个追星十年的老粉，51黑料上的爆料准确度是真的高，好几次提前爆出来的消息后来都实锤了。现在每天起床第一件事就是刷51黑料看今天有什么新瓜。',
    likes: 256,
  },
  {
    name: '深夜吃瓜人',
    avatar: '夜',
    time: '8小时前',
    content: '昨晚那个综艺剪辑的瓜太精彩了，看了一晚上停不下来。这个平台的分类也做得很好，想找什么类型的内容都能快速定位。已推荐给身边所有吃瓜小伙伴！',
    likes: 189,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">吃瓜群众说</h2>
            <p className="text-sm text-foreground-600 mt-2">看看大家都在讨论什么</p>
          </div>

          <div className="space-y-4">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="rounded-2xl bg-background-50 border border-background-200/60 p-5 md:p-6"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-black text-accent-600">{comment.avatar}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <h3 className="text-sm font-bold text-foreground-900">{comment.name}</h3>
                        <span className="text-xs text-foreground-500">{comment.time}</span>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                    <div className="flex items-center gap-4 mt-3">
                      <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-thumb-up-line text-sm w-3 h-3 flex items-center justify-center"></i>
                        </div>
                        {comment.likes}
                      </button>
                      <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-chat-1-line text-sm w-3 h-3 flex items-center justify-center"></i>
                        </div>
                        回复
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}